import { extendTailwindMerge } from 'tailwind-merge';

const BRAND_COLORS = [
  'bark',
  'moss',
  'leaf',
  'loam',
  'bone',
  'paper',
  'stone',
  'mute',
  'emergency',
  'success',
];

// tailwind-merge v3 does not auto-detect custom @theme colors. Register them
// here so utilities like text-bark / bg-paper / border-stone correctly
// conflict with their Tailwind-stock counterparts and resolve "last one wins".
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'text-color': [{ text: BRAND_COLORS }],
      'bg-color': [{ bg: BRAND_COLORS }],
      'border-color': [{ border: BRAND_COLORS }],
      'border-color-x': [{ 'border-x': BRAND_COLORS }],
      'border-color-y': [{ 'border-y': BRAND_COLORS }],
      'border-color-t': [{ 'border-t': BRAND_COLORS }],
      'border-color-r': [{ 'border-r': BRAND_COLORS }],
      'border-color-b': [{ 'border-b': BRAND_COLORS }],
      'border-color-l': [{ 'border-l': BRAND_COLORS }],
      'ring-color': [{ ring: BRAND_COLORS }],
      'divide-color': [{ divide: BRAND_COLORS }],
      'outline-color': [{ outline: BRAND_COLORS }],
    },
  },
});

export function cn(...classes: (string | false | null | undefined)[]): string {
  return customTwMerge(classes.filter(Boolean).join(' '));
}
